import { render, staticRenderFns } from "./AuthSetup.vue?vue&type=template&id=58981843&scoped=true"
import script from "./AuthSetup.vue?vue&type=script&lang=js"
export * from "./AuthSetup.vue?vue&type=script&lang=js"
import style0 from "./AuthSetup.vue?vue&type=style&index=0&id=58981843&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58981843",
  null
  
)

export default component.exports